// This icon file is generated automatically.
var PRetweetOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M.13 6.63h.99c.07 0 .12-.06.12-.13V2.51H9.5v1.14l.03.08c.05.05.13.06.18.02l2.24-1.76c.07-.08.06-.16 0-.2L9.71.02a.13.13 0 00-.21.1v1.14H1.12C.5 1.27 0 1.77 0 2.39V6.5c0 .07.06.13.13.13zm11.74-1.25h-.99a.13.13 0 00-.12.12v3.99H2.5V8.35c0-.03-.01-.05-.03-.08a.13.13 0 00-.18-.02L.05 10.01c-.07.08-.06.16 0 .2l2.24 1.76c.02.02.05.03.08.03.07 0 .13-.06.13-.13v-1.14h8.38c.62 0 1.12-.5 1.12-1.12V5.5a.13.13 0 00-.13-.13z", "fill-rule": "nonzero" } }] }, "name": "p-retweet", "theme": "outlined" };
export default PRetweetOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PRetweetOutlined.js
// module id = 3590
// module chunks = 0